$(document).ready(function(){
    ////////////////////////////////////////////////////////
    //                  MAP CONTACT             //
    ////////////////////////////////////////////////////////
    // on récupère l'id de retour
    let id = $('.filtres').data('params')['id'];
    // permet d'avoir le bon element
    if (terrains[id]) {
        longitude = terrains[id].longitude ? parseFloat(terrains[id].longitude) : 4.7580081;
        latitude = terrains[id].latitude ? parseFloat(terrains[id].latitude) : 44.7563668;
    } else if (terrains[0]) {
        longitude = terrains[0].longitude ? parseFloat(terrains[0].longitude) : 4.7580081
        latitude = terrains[0].latitude ? parseFloat(terrains[0].latitude) : 44.7563668;
    } else {
        longitude = 4.7580081;
        latitude = 44.7563668;
    }

    var map = L.map('terrainsMap', {
        center: [latitude,longitude],
        zoom: 10,
        scrollWheelZoom: false
    });

    var theme = L.tileLayer('https://c.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(map);

    var markerCluster = L.markerClusterGroup({
        showCoverageOnHover: false
    });


    let themePath = $('.tematik_page_list--programme').data('theme-path');
    var icon = L.icon({
        iconUrl: `${themePath}/application/themes/rampa/img/pictos/map.png`,
        iconSize: [36, 45],
        iconAnchor: [17, 45]
    });
    let markers = [];

    terrains.forEach(terrain => {
        // vérification des données
        terrain.livraison = terrain.livraison ? 'Livraison : ' + terrain.livraison +'<br />' : " ";
        terrain.localisation = terrain.localisation ? terrain.localisation +'<br />' : " ";
        terrain.prix = terrain.prix ? 'A partir de : ' + terrain.prix + '<br />' : " ";
        terrain.thumbnail = terrain.thumbnail ?
            '<div class="img-wrapper">\
                <img src="'+ terrain.thumbnail +'" alt="'+ terrain.titre +'"/>\
						</div>' : " "

        if (terrain.longitude != '' && terrain.latitude != '') {
            var template = '<a href="'+ terrain.url +'">\
					' + terrain.thumbnail + '\
						<div class="content-wrapper">\
							<span class="text-secondary tag">'+ terrain.type_bien +'</span>\
							<h6 class="titre3 text-uppercase text-black programmesMap-nom">'+ terrain.titre +'</h6>\
							<p class="programmes-infos">\
								<strong class="text-black">\
								'+ terrain.localisation +'\
									'+ terrain.livraison +'\
									'+ terrain.prix +'\
								</strong>\
							</p>\
						</div>\
					</a>';

            var marker = L.marker([terrain.latitude, terrain.longitude], {
                icon: icon
            }).addTo(markerCluster).bindPopup(template);
        }
        if (marker !== undefined) {
            markers.push(marker);
        }
    });

    map.addLayer(markerCluster);

    if (markers.length > 0) {
        const featureGroup = L.featureGroup(markers);
        map.fitBounds(featureGroup.getBounds());
    }


    // On va observer les modifications des attributs de la div contenant la carte
    // pour mettre à jour la taille de la carte.
    const mapContainer = document.querySelector('#typeContainer');
    const observer = new MutationObserver(() => {
        map.invalidateSize(true);
    })
    // On observe uniquement les modifications sur les attributs puisqu'on ne veut modifier la taille de
    // la carte que quand sa classe change.
    observer.observe(mapContainer, {attributes: true})
});
